<template>
  <div v-if="projects" class="project-list">
    <ProjectCard v-for="project in projects" :key="project.id" :project="project" :user="user" />
  </div>
</template>

<script lang="ts">
import ProjectCard from './ProjectCard';

export default {
  name: 'ProjectList',

  components: {
    ProjectCard,
  },

  props: {
    projects: {
      type: Array,
      required: true,
    },

    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.project-list {
  flex: 1 1 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 370px);
  gap: 24px;
}
</style>
